var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0364 14.4839H24.6681V7.9636C24.6681 7.41756 24.2505 7 23.7045 7H0.963598C0.417559 7 0 7.41756 0 7.9636V24.0557C0 24.6017 0.417559 25.0193 0.963598 25.0193H11.3705V27.2677H7.45182C6.90578 27.2677 6.48822 27.6852 6.48822 28.2313C6.48822 28.7773 6.90578 29.1949 7.45182 29.1949H17.1842C17.7302 29.1949 18.1478 28.7773 18.1478 28.2313C18.1478 27.6852 17.7302 27.2677 17.1842 27.2677H13.2976V25.0193H17.7623C18.3084 25.0193 18.7259 24.6017 18.7259 24.0557C18.7259 23.5096 18.3084 23.0921 17.7623 23.0921H1.9272V8.9272H22.7409V14.4839H21.2955C20.7495 14.4839 20.3319 14.9015 20.3319 15.4475V28.2634C20.3319 28.8094 20.7495 29.227 21.2955 29.227H29.0364C29.5824 29.227 30 28.8094 30 28.2634V15.4475C30 14.9015 29.5824 14.4839 29.0364 14.4839ZM28.0728 27.2998H22.2591V16.4111H28.0728V27.2998Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_37108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3119 13.75C24.86 13.75 22.0619 10.9519 22.0619 7.5C22.0619 4.04813 24.86 1.25 28.3119 1.25C31.7638 1.25 34.5619 4.04813 34.5619 7.5C34.5619 10.9519 31.7638 13.75 28.3119 13.75ZM27.6888 10L32.1075 5.58063L31.2238 4.69687L27.6888 8.2325L25.9206 6.46438L25.0369 7.34812L27.6888 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_37108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(20.8119)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTest);
export default __webpack_public_path__ + "static/media/deviceTest.3b4dc4cdc7640ac06945c042b20feab6.svg";
export { ForwardRef as ReactComponent };